import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

import { transformUserInfo } from './transform-user-info'

const DOC = gql`
  ${fragments.siblingUser.DOC}
  query MeUsersInApp($tenantId: ID!, $zoneId: ID!, $appId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          users {
            items {
              info {
                ...FragmentMeSiblingUser
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.MeUsersInAppQuery,
    readonly models.User[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'users',
          graphql.transformers.OUT.select(
            'items',
            graphql.transformers.OUT.default(
              graphql.transformers.OUT.list(
                graphql.transformers.OUT.custom(user =>
                  transformUserInfo(user?.info),
                ),
                { onNullish: 'remove' },
              ),
              [],
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.MeUsersInAppQuery,
  readonly models.User[],
  graphql.schema.MeUsersInAppQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
